@if (node1 | async; as item) {
  <div class="terms_block" >
    <!-- <div class="terms_block" *ngFor="let item1 of item">  -->
    <div class="terms_heading" [innerHTML]="item.h1content"></div>
    <p class="light_text" [innerHTML]="item.content"></p>
  </div>
}

